import React from 'react'


export const CardItem = ({ img, title, text, link }) => {
  return (
    <li className="card">
      <div className="card__img">
        <img src={img} alt={title} />
      </div>
      <div className="card__content">
        <h3 className="card__title" title={title}>{title}</h3>
        <p className="card__text" title={text}>{text}</p>
        <a href={link} target="_blank" rel="noreferrer" className="card__btn">
          LEARN MORE
        </a>
      </div>
    </li>
  )
}
